import { render } from "./pessahFlyer.vue?vue&type=template&id=3afdae2e&scoped=true"
import script from "./pessahFlyer.vue?vue&type=script&lang=js"
export * from "./pessahFlyer.vue?vue&type=script&lang=js"

import "./pessahFlyer.vue?vue&type=style&index=0&id=3afdae2e&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afdae2e"]])

export default __exports__